import { lineItemForReviewReasons, lineItemRejectReasons } from '@reveni-io/reveni-ui'

import { statuses } from '@/returns/constants'

export const reasons = {
  [statuses.rejected]: lineItemRejectReasons,
  [statuses.forReview]: lineItemForReviewReasons,
}

export const labels = {
  [statuses.rejected]: 'Motivo del rechazo',
  [statuses.forReview]: 'Situación del producto',
}
